import {PaymentCard} from "@falcon/services";
import * as moment from "moment";
import * as React from "react";
import {renderCardTypeName} from "../../../../../CommonFunctions";

interface IProps {
    mainCard?: PaymentCard
}

export class CreditCardSection extends React.Component<IProps> {

    constructor(props: any) {
        super(props);
    }

    public render(): JSX.Element {

        if (this.props.mainCard) {
            return (
                <div className="d-flex justify-content-center mt-3 credit-card-section margin-top-0" id={`card-${(this.props.mainCard.id).toString()}`}>
                    <div className="pt-2">{this.renderCardImage(this.props.mainCard)}</div>
                    <div className="text-left">
                        <div>
                            <span id="cardType">{renderCardTypeName(this.props.mainCard)}</span> ending in <b
                            className="font-weight-semi-bold" id="cardNumber">{this.props.mainCard.cardNumberObfuscated.split('******')[1]}</b>
                        </div>
                        <div className="mt-1 margin-top-0">
                            Expiry date: <span id="cardExpiryDate">{moment.monthsShort(this.props.mainCard.expiryMonth - 1)} '{this.props.mainCard.expiryYear}</span>
                        </div>
                    </div>
                </div>
            )
        } else {
            return (<div>No cards added to account</div>);
        }
    }

    private renderCardImage = (card: PaymentCard) => {
        if (card.cardType.includes("VISA")){
            return <img className="card-icon" alt="Visa icon" src="/img/visa-icon.svg"/>;
        }
        if (card.cardType.includes("MASTERCARD")){
            return <img className="card-icon" alt="Mastercard icon" src="/img/mastercard-icon.svg"/>;
        }
        return <React.Fragment/>;
    };
}



// WEBPACK FOOTER //
// ./src/pages/dashboard/common/payments/paymentDetails/CreditCardSection.tsx